import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import LoginPage from "./components/LoginPage/LoginPage";
import PrivateRoutes from "./routes/PrivateRoutes";
import { ToastContainer } from "react-toastify";
import CommonAuthCallback from "./components/Callbacks/CommonAuthCallback";
import AuthorizeCallback from "./components/Callbacks/AuthorizeCallback";
import MainDashboard from "./components/mainDashboard/MainDashboard";

function App() {
  return (
    <Router>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <Routes>
        <Route path="/login" element={<LoginPage />}></Route>
        {/* OAuth Callback Routes */}
        <Route path="/callback/common-auth" element={<CommonAuthCallback />} />
        <Route path="/callback/authorize" element={<AuthorizeCallback />} />

        <Route element={<PrivateRoutes />}>
          <Route path="/" element={<MainDashboard />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
